import { Markierung } from '@/domain/termine/components/Markierung/Markierung';
import { MitarbeiterSchichtenPopover } from '@/domain/termine/features/Calendar/shared/TerminInfo/Verknuepfungen/MitarbeiterSchichtenPopover';
import { markierungMapper } from '@/domain/termine/shared/types';
import { Schichten } from '@/domain/termine/shared/types/Schichten';
import { formatDateTimeRange } from '@/domain/termine/shared/utils/formatDateTime';
import { useTranslation } from 'react-i18next';

export function TerminVerknuepfungSchicht({
  schichten,
  hiddenArbeitsbereich,
}: {
  schichten: Schichten[];
  hiddenArbeitsbereich: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 max-h-60 overflow-y-auto">
      {schichten.map((schicht) => (
        <div
          key={schicht.id}
          className="flex gap-2 items-center justify-between w-full pt-3">
          <div className="flex flex-col flex-1 min-w-0">
            <span className="text-neutrals-900 text-sm">{schicht.name}</span>
            <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
              {schicht.markierung && (
                <Markierung color={markierungMapper[schicht.markierung].base} />
              )}
              {formatDateTimeRange(schicht.datum, schicht.beginn, schicht.ende)}
            </div>
          </div>
          <MitarbeiterSchichtenPopover mitarbeiterListe={schicht.mitarbeiter} />
        </div>
      ))}
      {hiddenArbeitsbereich && (
        <span className="text-xs py-3">
          {t('domain.termine.hiddenArbeitsbereich')}
        </span>
      )}
    </div>
  );
}
